/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoicePersonLightResponse } from './InvoicePersonLightResponse';
import {
    InvoicePersonLightResponseFromJSON,
    InvoicePersonLightResponseFromJSONTyped,
    InvoicePersonLightResponseToJSON,
    InvoicePersonLightResponseToJSONTyped,
} from './InvoicePersonLightResponse';
import type { TransactionResponse } from './TransactionResponse';
import {
    TransactionResponseFromJSON,
    TransactionResponseFromJSONTyped,
    TransactionResponseToJSON,
    TransactionResponseToJSONTyped,
} from './TransactionResponse';
import type { PatientDocumentResponse } from './PatientDocumentResponse';
import {
    PatientDocumentResponseFromJSON,
    PatientDocumentResponseFromJSONTyped,
    PatientDocumentResponseToJSON,
    PatientDocumentResponseToJSONTyped,
} from './PatientDocumentResponse';
import type { FinancialGroupLightResponse } from './FinancialGroupLightResponse';
import {
    FinancialGroupLightResponseFromJSON,
    FinancialGroupLightResponseFromJSONTyped,
    FinancialGroupLightResponseToJSON,
    FinancialGroupLightResponseToJSONTyped,
} from './FinancialGroupLightResponse';
import type { ReminderGroupResponse } from './ReminderGroupResponse';
import {
    ReminderGroupResponseFromJSON,
    ReminderGroupResponseFromJSONTyped,
    ReminderGroupResponseToJSON,
    ReminderGroupResponseToJSONTyped,
} from './ReminderGroupResponse';
import type { TiersPayantLightResponse } from './TiersPayantLightResponse';
import {
    TiersPayantLightResponseFromJSON,
    TiersPayantLightResponseFromJSONTyped,
    TiersPayantLightResponseToJSON,
    TiersPayantLightResponseToJSONTyped,
} from './TiersPayantLightResponse';

/**
 * Response for get invoices
 * @export
 * @interface InvoiceResponse
 */
export interface InvoiceResponse {
    /**
     * Unique identifier of the invoice
     * @type {number}
     * @memberof InvoiceResponse
     */
    id?: number;
    /**
     * ID of parent invoice for reminders, credit notes, and debit notes
     * @type {number}
     * @memberof InvoiceResponse
     */
    parentInvoiceId?: number | null;
    /**
     * the amount of the invoice
     * @type {string}
     * @memberof InvoiceResponse
     */
    amount?: string;
    /**
     * the creation date of the invoice
     * @type {string}
     * @memberof InvoiceResponse
     */
    created?: string;
    /**
     * the code iso of currency
     * @type {string}
     * @memberof InvoiceResponse
     */
    currencyIso?: string;
    /**
     * the due datetime
     * @type {string}
     * @memberof InvoiceResponse
     */
    dueDateTime?: string;
    /**
     * the datetime of the invoice
     * @type {string}
     * @memberof InvoiceResponse
     */
    invoiceDateTime?: string;
    /**
     * direction of the invoice
     * @type {string}
     * @memberof InvoiceResponse
     */
    invoiceDirection?: string;
    /**
     * Type of invoice
     * @type {string}
     * @memberof InvoiceResponse
     */
    invoiceType?: string;
    /**
     * information of the invoice
     * @type {string}
     * @memberof InvoiceResponse
     */
    invoiceInfo?: string;
    /**
     * the reference of the invoice
     * @type {string}
     * @memberof InvoiceResponse
     */
    invoiceReference?: string;
    /**
     * the status of the invoice
     * @type {string}
     * @memberof InvoiceResponse
     */
    invoiceStatus?: string;
    /**
     * true if invoice is cancellable by eConnector
     * @type {boolean}
     * @memberof InvoiceResponse
     */
    isCancellableByEConnector?: boolean;
    /**
     * the remaining balance
     * @type {string}
     * @memberof InvoiceResponse
     */
    remainingBalance?: string;
    /**
     * 
     * @type {FinancialGroupLightResponse}
     * @memberof InvoiceResponse
     */
    financialGroup?: FinancialGroupLightResponse;
    /**
     * 
     * @type {ReminderGroupResponse}
     * @memberof InvoiceResponse
     */
    latestReminderGroup?: ReminderGroupResponse;
    /**
     * 
     * @type {InvoicePersonLightResponse}
     * @memberof InvoiceResponse
     */
    pwrHealthPro?: InvoicePersonLightResponse;
    /**
     * 
     * @type {InvoicePersonLightResponse}
     * @memberof InvoiceResponse
     */
    pwrCounterParty?: InvoicePersonLightResponse;
    /**
     * 
     * @type {Array<TransactionResponse>}
     * @memberof InvoiceResponse
     */
    transactions?: Array<TransactionResponse>;
    /**
     * 
     * @type {Array<TransactionResponse>}
     * @memberof InvoiceResponse
     */
    secondaryTransactions?: Array<TransactionResponse>;
    /**
     * 
     * @type {PatientDocumentResponse}
     * @memberof InvoiceResponse
     */
    patientDocument?: PatientDocumentResponse;
    /**
     * 
     * @type {Array<TiersPayantLightResponse>}
     * @memberof InvoiceResponse
     */
    tiersPayants?: Array<TiersPayantLightResponse>;
    /**
     * 
     * @type {Array<TiersPayantLightResponse>}
     * @memberof InvoiceResponse
     */
    tiersPayantSocials?: Array<TiersPayantLightResponse>;
}

/**
 * Check if a given object implements the InvoiceResponse interface.
 */
export function instanceOfInvoiceResponse(value: object): value is InvoiceResponse {
    return true;
}

export function InvoiceResponseFromJSON(json: any): InvoiceResponse {
    return InvoiceResponseFromJSONTyped(json, false);
}

export function InvoiceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'parentInvoiceId': json['parentInvoiceId'] == null ? undefined : json['parentInvoiceId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'created': json['created'] == null ? undefined : json['created'],
        'currencyIso': json['currencyIso'] == null ? undefined : json['currencyIso'],
        'dueDateTime': json['dueDateTime'] == null ? undefined : json['dueDateTime'],
        'invoiceDateTime': json['invoiceDateTime'] == null ? undefined : json['invoiceDateTime'],
        'invoiceDirection': json['invoiceDirection'] == null ? undefined : json['invoiceDirection'],
        'invoiceType': json['invoiceType'] == null ? undefined : json['invoiceType'],
        'invoiceInfo': json['invoiceInfo'] == null ? undefined : json['invoiceInfo'],
        'invoiceReference': json['invoiceReference'] == null ? undefined : json['invoiceReference'],
        'invoiceStatus': json['invoiceStatus'] == null ? undefined : json['invoiceStatus'],
        'isCancellableByEConnector': json['isCancellableByEConnector'] == null ? undefined : json['isCancellableByEConnector'],
        'remainingBalance': json['remainingBalance'] == null ? undefined : json['remainingBalance'],
        'financialGroup': json['financialGroup'] == null ? undefined : FinancialGroupLightResponseFromJSON(json['financialGroup']),
        'latestReminderGroup': json['latestReminderGroup'] == null ? undefined : ReminderGroupResponseFromJSON(json['latestReminderGroup']),
        'pwrHealthPro': json['pwrHealthPro'] == null ? undefined : InvoicePersonLightResponseFromJSON(json['pwrHealthPro']),
        'pwrCounterParty': json['pwrCounterParty'] == null ? undefined : InvoicePersonLightResponseFromJSON(json['pwrCounterParty']),
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(TransactionResponseFromJSON)),
        'secondaryTransactions': json['secondaryTransactions'] == null ? undefined : ((json['secondaryTransactions'] as Array<any>).map(TransactionResponseFromJSON)),
        'patientDocument': json['patientDocument'] == null ? undefined : PatientDocumentResponseFromJSON(json['patientDocument']),
        'tiersPayants': json['tiersPayants'] == null ? undefined : ((json['tiersPayants'] as Array<any>).map(TiersPayantLightResponseFromJSON)),
        'tiersPayantSocials': json['tiersPayantSocials'] == null ? undefined : ((json['tiersPayantSocials'] as Array<any>).map(TiersPayantLightResponseFromJSON)),
    };
}

export function InvoiceResponseToJSON(json: any): InvoiceResponse {
    return InvoiceResponseToJSONTyped(json, false);
}

export function InvoiceResponseToJSONTyped(value?: InvoiceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parentInvoiceId': value['parentInvoiceId'],
        'amount': value['amount'],
        'created': value['created'],
        'currencyIso': value['currencyIso'],
        'dueDateTime': value['dueDateTime'],
        'invoiceDateTime': value['invoiceDateTime'],
        'invoiceDirection': value['invoiceDirection'],
        'invoiceType': value['invoiceType'],
        'invoiceInfo': value['invoiceInfo'],
        'invoiceReference': value['invoiceReference'],
        'invoiceStatus': value['invoiceStatus'],
        'isCancellableByEConnector': value['isCancellableByEConnector'],
        'remainingBalance': value['remainingBalance'],
        'financialGroup': FinancialGroupLightResponseToJSON(value['financialGroup']),
        'latestReminderGroup': ReminderGroupResponseToJSON(value['latestReminderGroup']),
        'pwrHealthPro': InvoicePersonLightResponseToJSON(value['pwrHealthPro']),
        'pwrCounterParty': InvoicePersonLightResponseToJSON(value['pwrCounterParty']),
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(TransactionResponseToJSON)),
        'secondaryTransactions': value['secondaryTransactions'] == null ? undefined : ((value['secondaryTransactions'] as Array<any>).map(TransactionResponseToJSON)),
        'patientDocument': PatientDocumentResponseToJSON(value['patientDocument']),
        'tiersPayants': value['tiersPayants'] == null ? undefined : ((value['tiersPayants'] as Array<any>).map(TiersPayantLightResponseToJSON)),
        'tiersPayantSocials': value['tiersPayantSocials'] == null ? undefined : ((value['tiersPayantSocials'] as Array<any>).map(TiersPayantLightResponseToJSON)),
    };
}

